"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFHTrendTransaction = void 0;
const react_1 = __importStar(require("react"));
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
const useGFHTrendTransaction = (props) => {
    const { tradeApi, active, detailInfo, orderId, orderType, trend, historyStraddle, conditionAndNotTriggeredAbsCb, onSuccess, onFailure, } = props;
    const nextPageRef = (0, react_1.useRef)("");
    const [listLoading, changeFetchLoading] = (0, react_1.useState)(false);
    const [gridPairOrderList, changeGridPairList] = react_1.default.useState();
    const [nextPageToken, setNextPageToken] = react_1.default.useState();
    (0, react_1.useEffect)(() => {
        changeGridPairList([]);
    }, [trend, changeGridPairList]);
    (0, react_1.useEffect)(() => {
        nextPageRef.current = "";
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId]);
    (0, react_1.useEffect)(() => {
        if (conditionAndNotTriggeredAbsCb) {
            conditionAndNotTriggeredAbsCb();
        }
        if (!tradeApi || !active) {
            return;
        }
        if (!detailInfo || (detailInfo && (detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.isConditionAndNotTriggered))) {
            return;
        }
        // 确保当nextPageRef的token没有了以后，传递给后端的nextPageToken一定为空
        let tempToken = nextPageToken;
        if (nextPageRef.current === "" && nextPageToken !== "") {
            tempToken = "";
        }
        changeFetchLoading(true);
        const subscription = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.queryGridPairedCloseOrderList(orderId, orderType, tempToken, trend), {
            name: "getQueryGridCloseOrdersObservable",
            maxRetryCount: 4,
        })
            .pipe((0, rxjs_1.map)((result) => {
            return {
                pairedOrderList: result.pairedOrderList,
                nextPageToken: result.nextPageToken,
            };
        }))
            .subscribe({
            next: (result) => {
                let resultPairedOrderList = result.pairedOrderList;
                let mergeResult;
                if (!tempToken) {
                    mergeResult = resultPairedOrderList;
                }
                else {
                    mergeResult = gridPairOrderList ? [...gridPairOrderList, ...resultPairedOrderList] : resultPairedOrderList;
                }
                changeGridPairList(mergeResult);
                changeFetchLoading(false);
                nextPageRef.current = result.nextPageToken;
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            error: (error) => {
                changeFetchLoading(false);
                onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            },
            complete: () => {
                changeFetchLoading(false);
            },
        });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [tradeApi, orderId, nextPageToken, orderType, active, trend]);
    const { pairs, dataSource } = (0, react_1.useMemo)(() => {
        if (!gridPairOrderList || gridPairOrderList.length === 0 || historyStraddle === undefined) {
            return { pairs: [], dataSource: [{ data: [] }] };
        }
        let count = historyStraddle;
        const _pairs = gridPairOrderList.map((pairInfo, index) => {
            let profit = undefined;
            if (pairInfo.sellOrder && pairInfo.buyOrder) {
                profit = new trade_utils_lib_1.SafeDecimal(pairInfo.sellOrder.exchangeCustomOrder.filled_value)
                    .sub(new trade_utils_lib_1.SafeDecimal(pairInfo.buyOrder.exchangeCustomOrder.filled_value))
                    .sub(new trade_utils_lib_1.SafeDecimal(pairInfo.sellOrder.exchangeCustomOrder.feeInQuote))
                    .sub(new trade_utils_lib_1.SafeDecimal(pairInfo.buyOrder.exchangeCustomOrder.feeInQuote));
            }
            const sellTime = pairInfo.sellOrder ? pairInfo.sellOrder.lastTradeTime : 0;
            const buyTime = pairInfo.buyOrder ? pairInfo.buyOrder.lastTradeTime : 0;
            const indexPos = profit && !profit.isNaN() ? count-- : 0;
            return {
                tag: pairInfo.tag,
                sellOrder: pairInfo.sellOrder,
                buyOrder: pairInfo.buyOrder,
                lastTradeTimestamp: Math.max(buyTime, sellTime),
                profit: profit && !profit.isNaN() ? profit.toNumber() : undefined,
                index: indexPos,
            };
        });
        return { pairs: _pairs, dataSource: [{ data: _pairs || [] }] };
    }, [gridPairOrderList, historyStraddle]);
    return {
        nextPageRef,
        listLoading,
        nextPageToken,
        setNextPageToken,
        pairs,
        dataSource,
    };
};
exports.useGFHTrendTransaction = useGFHTrendTransaction;
